import type { PromocodeCreateValues, Promocode } from '../model/interfaces'
import type { ApiResponse } from '@shared/api'

import { getAxiosErrorMessage } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

import { usePromocodesStore } from '../model/store'

/**
 * `POST /admin-api/promocodes` — create a promocode. A blank `name` lets the backend auto-generate a code.
 */
export const usePromocodeCreate = async (payload: PromocodeCreateValues): Promise<Promocode | null> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()
  const store = usePromocodesStore()

  const url = useAdminRoutes('admin.promocodes.store')

  store.setSaving(true)

  try {
    if (!url) {
      toast.error('Unexpected error. Invalid request URL.')
      return null
    }

    const { data } = await $axios.post<ApiResponse>(url, payload)

    if (!data.success) {
      toast.error(data.message)
      return null
    }

    toast.success(data.message)

    return data.data || null
  } catch (err: unknown) {
    toast.error(getAxiosErrorMessage(err))
    return null
  } finally {
    store.setSaving(false)
  }
}
